import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_shell/behavior/banners")({
  beforeLoad: () => {
    throw redirect({
      to: "/chatbot",
      search: { tab: "banners" },
    });
  },
});
